import { PrimitiveField } from "@opendaw/lib-box";
import { isDefined, Option, panic } from "@opendaw/lib-std";
import { Guard } from "./Guard";
export var Fields;
(function (Fields) {
    const specs = new WeakMap();
    Fields.bind = (context, target, spec, prefix = "") => {
        specs.set(target, { ...(specs.get(target) ?? {}), ...spec });
        Object.entries(spec).forEach(([key, entry]) => {
            const name = `${prefix}${key}`;
            if (entry instanceof PrimitiveField) {
                Fields.accessor(context, target, key, name, entry);
            }
            else if (Array.isArray(entry)) {
                const array = [];
                entry.forEach((element, index) => {
                    if (element instanceof PrimitiveField) {
                        Fields.accessor(context, array, String(index), `${name}.${index}`, element);
                    }
                    else {
                        array.push(Fields.bind(context, {}, element, `${name}.${index}.`));
                    }
                });
                Object.defineProperty(target, key, { enumerable: true, value: Object.freeze(array) });
            }
            else {
                Object.defineProperty(target, key, {
                    enumerable: true, value: Fields.bind(context, {}, entry, `${name}.`)
                });
            }
        });
        return target;
    };
    Fields.resolve = (target, path) => {
        const segments = path.split(".");
        const walk = (spec, index) => {
            if (spec instanceof PrimitiveField) {
                return index === segments.length ? Option.wrap(spec) : Option.None;
            }
            if (index === segments.length) {
                return Option.None;
            }
            const segment = segments[index];
            if (Array.isArray(spec)) {
                const element = spec[Number(segment)];
                return isDefined(element) ? walk(element, index + 1) : Option.None;
            }
            const entry = spec[segment];
            return isDefined(entry) ? walk(entry, index + 1) : Option.None;
        };
        const spec = specs.get(target);
        return isDefined(spec) ? walk(spec, 0) : Option.None;
    };
    Fields.paths = (target) => {
        const result = [];
        const walk = (spec, prefix) => {
            if (spec instanceof PrimitiveField) {
                result.push(prefix);
            }
            else if (Array.isArray(spec)) {
                spec.forEach((element, index) => walk(element, `${prefix}.${index}`));
            }
            else {
                Object.entries(spec)
                    .forEach(([key, entry]) => walk(entry, prefix.length === 0 ? key : `${prefix}.${key}`));
            }
        };
        const spec = specs.get(target);
        if (isDefined(spec)) {
            walk(spec, "");
        }
        return result;
    };
    Fields.accessor = (context, target, key, name, field) => {
        Object.defineProperty(target, key, {
            enumerable: true,
            get: () => attached(field, name).getValue(),
            set: (value) => context.edit(() => attached(field, name).setValue(Guard.field(field, value, name)))
        });
    };
    const attached = (field, name) => field.isAttached() ? field : panic(`${name}: ${field.box.name} has been removed`);
})(Fields || (Fields = {}));
